import "core-js/modules/es.function.name.js";
import { Core } from "@faire/design-tokens";
import { Close } from "@faire/web/slate/icons/foundation/Close";
import { File } from "@faire/web/slate/icons/foundation/File";
import { Typography } from "@faire/web/slate/Typography";
import * as React from "react";
import styled from "styled-components";
export var UploadedFile = function UploadedFile(_ref) {
  var file = _ref.file,
    onRemove = _ref.onRemove;
  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(File, {
    color: "inherit",
    fontSize: "18px"
  }), /*#__PURE__*/React.createElement(Typography, null, file.name)), /*#__PURE__*/React.createElement(IconButton, {
    onClick: onRemove
  }, /*#__PURE__*/React.createElement(Close, {
    color: "inherit",
    fontSize: "21px"
  })));
};
var Wrapper = styled.article.withConfig({
  displayName: "UploadedFile__Wrapper"
})(["display:flex;gap:10px;align-items:center;"]);
var Box = styled.div.withConfig({
  displayName: "UploadedFile__Box"
})(["padding:18px;display:flex;gap:10px;border:1px solid ", ";flex:1;"], Core.border.muted);
var IconButton = styled.button.withConfig({
  displayName: "UploadedFile__IconButton"
})(["border:none;box-shadow:none;padding:0;margin:0;background:transparent;cursor:pointer;"]);